// extracted by mini-css-extract-plugin
module.exports = {"videoBehindPlaceholder":"VideoBehindPlaceholder-module--video-behind-placeholder--2z_B7"};